var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Underline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 24053",
    transform: "translate(536 259)",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-536 -259)",
    clipPath: "url(#Underline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25232",
    d: "M540.876 270.64v-8.156a2.27 2.27 0 01.469-1.562 1.578 1.578 0 011.231-.515 1.619 1.619 0 011.267.521 2.27 2.27 0 01.469 1.562v8.341a7.609 7.609 0 00.316 2.376 2.744 2.744 0 001.128 1.476 4.144 4.144 0 002.267.524 3.4 3.4 0 002.846-1.067 5.242 5.242 0 00.833-3.245v-8.41a2.286 2.286 0 01.463-1.568 1.582 1.582 0 011.238-.51 1.637 1.637 0 011.255.515 2.23 2.23 0 01.48 1.567v8.156a12.066 12.066 0 01-.388 3.315 5.126 5.126 0 01-1.463 2.337 5.684 5.684 0 01-2.152 1.249 9.416 9.416 0 01-2.869.393 11.827 11.827 0 01-3.366-.422 5.387 5.387 0 01-2.3-1.307 5.27 5.27 0 01-1.309-2.267 11.532 11.532 0 01-.415-3.303zm-1.874 9.643h18v1.316h-18z"
  }))));
}
export default SvgUnderline;